import { freedomApp } from 'freedom-shared';

export const withFreedomApp = () => {
  freedomApp.lib.setupEmptyWebViewApi();
  freedomApp.lib.getProductName('avia');
};
